import { render } from "./FormFile.vue?vue&type=template&id=ebc80bec"
import script from "./FormFile.vue?vue&type=script&lang=js"
export * from "./FormFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__